import Clickable from '/components/Clickable';
import PropTypes from 'prop-types';
import { useWizard } from 'react-use-wizard';

const StepNavigation = ({ builderConfig, packConfig, updatePackConfig }) => {
	const { activeStep, goToStep } = useWizard();
	const isCouples = builderConfig.id === 'couples';

	if (activeStep === 0 && (!isCouples || packConfig.currentProductConfigIndex === 0)) {
		return null;
	}
	const previousStepIndex = activeStep - 1;

	const previousStep = () => {
		if (isCouples && packConfig.currentProductConfigIndex !== 0) {
			const nextPackIndex =
				activeStep === 0
					? packConfig.currentProductConfigIndex - 1
					: packConfig.currentProductConfigIndex;
			updatePackConfig('currentProductConfigIndex', nextPackIndex);
			goToStep(0);
			return;
		}
		goToStep(previousStepIndex);
	};

	return (
		<div className="flex justify-between m-2">
			<Clickable
				color="v2-brown-darker"
				onClick={() => previousStep()}
				className="font-bold px-4"
				size="xs"
				variant="round-outlined">
				Back
			</Clickable>
		</div>
	);
};

StepNavigation.propTypes = {
	builderConfig: PropTypes.object,
	packConfig: PropTypes.object,
	updatePackConfig: PropTypes.func,
};

export default StepNavigation;
